import { compose } from 'recompose';

import ContactsFilter from './ContactsFilter';

const enhance = compose();

export default enhance(ContactsFilter);
